import { call } from '@advanza/api'
import { Col, Row } from '@advanza/grid'
import { Button, Divider, LoadingDots } from '@advanza/ui'
import DatePicker from 'components/DatePicker'
import Page from 'components/ui/Page'
import { format, subDays } from 'date-fns'
import { useState } from 'react'

const AdSheetsPage = () => {
    const [fromDate, setFromDate] = useState(format(subDays(new Date(), 50), 'yyyy-MM-dd'))
    const [toDate, setToDate] = useState(format(subDays(new Date(), 2), 'yyyy-MM-dd'))
    const [isBusy, setIsBusy] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const onCalc = async () => {
        setIsBusy(true)
        setError(null)

        try {
            return await call(`office/providers/calc-sheet/coverage/${fromDate}/${toDate}`)
        } catch (response: any) {
            setIsBusy(false)
            setError(response.error || 'Error')
        }
    }

    return (
        <Page title="Ad sheets">
            <Divider m />
            <Row top="xs">
                <Col x>
                    <DatePicker
                        dayPickerProps={{
                            disabled: { before: subDays(new Date(), 60), after: new Date(toDate) },
                            defaultMonth: new Date(fromDate),
                        }}
                        onChange={(e) => setFromDate(e.target.value)}
                        opened
                        legend
                        placeholder="From date (inclusive)"
                        value={fromDate}
                    />
                </Col>
                <Col x>
                    <DatePicker
                        dayPickerProps={{
                            disabled: { before: new Date(fromDate), after: subDays(new Date(), 1) },
                            defaultMonth: new Date(toDate),
                        }}
                        onChange={(e) => setToDate(e.target.value)}
                        opened
                        legend
                        placeholder="To date (inclusive)"
                        value={toDate}
                    />
                </Col>
            </Row>
            <Divider m />
            <Button disabled={isBusy} onClick={onCalc}>
                {isBusy ? (
                    <>
                        Busy <LoadingDots />
                    </>
                ) : (
                    'Calculate'
                )}
            </Button>
            {error && (
                <>
                    <Divider m />
                    <div style={{ color: 'red' }}>{error}</div>
                </>
            )}
            <Divider m />
            <div className="max-w-xl">
                The resulting csv file will be sent to Slack when done. The coverage sheet does not
                include campaigns without keywords (like Performance Max). If the keyword, ad group
                name and campaign name don't contain a place name, the stats will go under coverage
                unknown (empty).
            </div>
        </Page>
    )
}

export default AdSheetsPage
